var Panic = (msg) => {
	// alert(msg); // uncomment to debug if something's eating your panic exceptions
	throw new Error(msg);
};

export default Panic



// WEBPACK FOOTER //
// ./src/Panic.js